import {SYNC_ACTION_TYPES} from '../../actions/sync/sync';

const initialState = {
  stats: {
    activeJobs: 0,
    completedToday: 0,
    failedJobs: 0,
  },
  jobs: [],
  currentJob: null,
  loading: false,
  error: null,
  lastUpdated: null,
};

const syncReducer = (state = initialState, action) => {
  switch (action.type) {
    case SYNC_ACTION_TYPES.FETCH_STATS_REQUEST:
      return {
        ...state,
        loading: action.meta?.background ? state.loading : true,
        error: null,
      };
    case SYNC_ACTION_TYPES.FETCH_STATS_SUCCESS:
      return {
        ...state,
        loading: false,
        stats: action.payload,
        lastUpdated: Date.now(),
      };
    case SYNC_ACTION_TYPES.FETCH_STATS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SYNC_ACTION_TYPES.FETCH_JOBS_REQUEST:
      return {
        ...state,
        loading: action.meta?.background ? state.loading : true,
        error: null,
      };
    case SYNC_ACTION_TYPES.FETCH_JOBS_SUCCESS:
      return {
        ...state,
        loading: false,
        jobs: action.payload.jobs,
        lastUpdated: Date.now(),
      };
    case SYNC_ACTION_TYPES.FETCH_JOBS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SYNC_ACTION_TYPES.FETCH_JOB_DETAILS_REQUEST:
      return {
        ...state,
        loading: action.meta?.background ? state.loading : true,
        error: null,
      };
    case SYNC_ACTION_TYPES.FETCH_JOB_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        currentJob: action.payload,
        lastUpdated: Date.now(),
      };
    case SYNC_ACTION_TYPES.FETCH_JOB_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SYNC_ACTION_TYPES.START_SYNC_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SYNC_ACTION_TYPES.START_SYNC_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case SYNC_ACTION_TYPES.START_SYNC_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SYNC_ACTION_TYPES.CLEAR_CURRENT_JOB:
      return {
        ...state,
        currentJob: null,
      };

    case SYNC_ACTION_TYPES.CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export const sync = syncReducer;
export default syncReducer;
